<template>
  <CModal
    :width="800"
    :value="show"
    @on-visible-change="(e) => $emit('change', e)"
    :title="title"
    footerHide
  >
    <h2 class="d-h2">
      {{
        detail.type == 1
          ? "综合诉求"
          : detail.type == 2
          ? "用工诉求"
          : detail.type == 3
          ? "金融诉求"
          : detail.type == 4
          ? "走访诉求"
          : detail.type == 5
          ? "科创诉求"
          : detail.type == 6
          ? "校企通"
          : "企业12345热线"
      }}
    </h2>
    <h3 class="d-h3">基础信息</h3>
    <template v-if="detail.type != 7">
    <div class="flex-start mb16">
      <div class="flex-0 flex-start">
        <span class="flex-label"> 企业名称： </span>
        <span class="flex-0">
          {{ detail.name }}
        </span>
      </div>
      <div class="flex-0 flex-start">
        <span class="flex-label"> 统一社会信用代码： </span>
        <span class="flex-0">
          {{ detail.code }}
        </span>
      </div>
    </div>
    </template>
    <div class="flex-start mb16">
      <div class="flex-0 flex-start">
        <span class="flex-label"> 发布人： </span>
        <span class="flex-0" v-if="detail.type ===7">
          {{ detail.tqtAppeal.concat ||'' }}
        </span>
        <span class="flex-0" v-else>
          {{ detail.concat ||'' }}
        </span>
      </div>
      <div class="flex-0 flex-start">
        <span class="flex-label"> 发布时间： </span>
        <span class="flex-0" v-if="detail.type ===7">
          {{ detail.tqtAppeal.createTime?dayjs(detail.tqtAppeal.createTime).format("YYYY-MM-DD"):'' }}
        </span>
        <span class="flex-0" v-else>
          {{ detail.createTime?dayjs(detail.createTime).format("YYYY-MM-DD"):'' }}
        </span>
      </div>
    </div>
    <h3 v-if="detail.type == 7" class="d-h3">诉求信息</h3>
    <div class="flex-start mb16">
      <div class="flex-0 flex-start">
        <span class="flex-label">
          {{ detail.type == 7 ? "姓名" : "联系人" }}：
        </span>
        <span class="flex-0" v-if="detail.type ===7">
          {{ detail.tqtAppeal.concat }}
        </span>
        <span class="flex-0" v-else>
          {{ detail.concat }}
        </span>
      </div>
      <div class="flex-0 flex-start">
        <span class="flex-label"> 联系电话： </span>
        <span class="flex-0" v-if="detail.type ===7">
          {{ detail.tqtAppeal.phone }}
        </span>
        <span class="flex-0" v-else>
          {{ detail.phone }}
        </span>
      </div>
    </div>
    <h3 v-if="detail.type == 2" class="d-h3">用工信息</h3>
    <h3 class="d-h3" v-if="detail.type == 3">存量贷款情况</h3>
    <h3 class="d-h3" v-if="detail.type == 6">应届生诉求</h3>
    <div class="sq-b" v-for="item in detail.tqtAppealDetailList" :key="item.id">
      <template v-if="detail.type == 6">
        <div class="flex-start mb16">
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >学历要求：</span
            >
            <span class="flex-0">
              {{ item.eduReq }}
            </span>
          </div>
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >专业要求：</span
            >
            <span class="flex-0">
              {{ item.majorReq }}
            </span>
          </div>
        </div>
        <div class="flex-start mb16">
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >意向院校：</span
            >
            <span class="flex-0">
              {{ item.yxCollege }}
            </span>
          </div>
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >招聘人数：</span
            >
            <span class="flex-0">
              {{ item.num }}
            </span>
          </div>
        </div>
        <div class="flex-start mb16">
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >工资待遇：</span
            >
            <span class="flex-0">
              {{ item.money }}
            </span>
          </div>
        </div>
      </template>
      <template v-if="detail.type == 2 || detail.type == 3">
        <div class="flex-start mb16">
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >{{ detail.type == 2 ? "招聘工种" : "金额（万元）" }}：</span
            >
            <span class="flex-0">
              {{ detail.type == 2 ? item.gz : item.cldkMoney }}
            </span>
          </div>
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >{{ detail.type == 2 ? "招聘人数" : "合作银行" }}：</span
            >
            <span class="flex-0">
              {{ detail.type == 2 ? item.num : item.cldkhzyh }}
            </span>
          </div>
        </div>
        <div class="flex-start mb16">
          <div class="flex-0 flex-start">
            <span class="flex-label"
              >{{ detail.type == 2 ? "工资待遇" : "处置意向" }}：</span
            >
            <span class="flex-0">
              {{ detail.type == 2 ? item.money : item.czyx }}
            </span>
          </div>
        </div>
      </template>
    </div>
    <h3 class="d-h3 mt16" v-if="detail.type == 3">新增贷款意向</h3>
    <div v-if="detail.type == 3" class="flex-start pb16 sq-b">
      <div class="flex-0 flex-start">
        <span class="flex-label">金额（万元）：</span>
        <span class="flex-0">
          {{ detail.xzdkMoney }}
        </span>
      </div>
      <div class="flex-0 flex-start">
        <span class="flex-label">合作银行：</span>
        <span class="flex-0">
          {{ detail.xzdkhzyh }}
        </span>
      </div>
    </div>
    <div v-if="detail.type == 7" class="flex-start mb16 mt16">
      <div class="flex-0 flex-start">
        <span class="flex-label">企业名称： </span>
        <span class="flex-0">
          {{ detail.tqtAppeal.ygNote }}
        </span>
      </div>
    </div>
    <div v-if="detail.type == 7" class="flex-start mb16 mt16">
    <div class="flex-0 flex-start">
      <span class="flex-label">诉求内容： </span>
      <span class="flex-0">
          {{ detail.tqtAppeal.content }}
        </span>
    </div>
      <div class="flex-0 flex-start">
        <span class="flex-label">是否公开市民信息： </span>
        <span class="flex-0">
          {{ detail.tqtAppeal.whConPerInfo ==0?'是':'否' }}
        </span>
      </div>
  </div>
    <div v-if="detail.type == 7" class="flex-start mb16 mt16">
      <div class="flex-0 flex-start">
        <span class="flex-label">诉求地址： </span>
        <span class="flex-0">
          {{ detail.tqtAppeal.busiAddress }}
        </span>
      </div>
      <div class="flex-0 flex-start">
        <span class="flex-label">是否完结： </span>
        <span class="flex-0">
          {{ detail.tqtAppeal.statusFinish ==1?'已完结':'未完结' }}
        </span>
      </div>
    </div>
    <div v-else class="flex-start mb16 mt16">
      <div class="flex-0 flex-start">
        <span class="flex-label">详细内容： </span>
        <span class="flex-0">
          {{ detail.reqNote || detail.ygNote || detail.content }}
        </span>
      </div>
    </div>
    <div v-if="detail.type == 7&&detail.govHotline">
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">归属地： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.areaName }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">工单编号： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.busiNumber }}
        </span>
        </div>

      </div>
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">一级业务类型（编码）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeId }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">一级业务类型（名称）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeName }}
        </span>
        </div>

      </div>
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">二级业务类型（编码）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeChildId }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">二级业务类型（名称）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeChildName }}
        </span>
        </div>

      </div>
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">三级业务类型（编码）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeGrandsonId }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">三级业务类型（名称）： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.businessTypeGrandsonName }}
        </span>
        </div>

      </div>
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">备注： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.comments }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">工单内容： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.contentText }}
        </span>
        </div>

      </div>
      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">创建时间： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.createTime?dayjs(detail.govHotline.result.busiForm.createTime).format("YYYY-MM-DD"):'' }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">客户姓名： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.cusName }}
        </span>
        </div>

      </div>

      <div class="flex-start mb16 mt16">
        <div class="flex-0 flex-start">
          <span class="flex-label">联系号码： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.cusPhone }}
        </span>
        </div>
        <div class="flex-0 flex-start">
          <span class="flex-label">客户性别： </span>
          <span class="flex-0">
          {{ detail.govHotline.result.busiForm.cusSex ==1?'男':detail.govHotline.result.busiForm.cusSex==2?'女':'' }}
        </span>
        </div>

      </div>
    </div>

  </CModal>
</template>
<script>
import CModal from "@/components/cModel";
import dayjs from "dayjs";

export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    title: {
      type: String,
      default: "详情",
    },
  },
  components: {
    CModal,
  },
  data() {
    return {};
  },
  methods: {
    dayjs,
  },
};
</script>

<style scoped>
.d-h2 {
  font-weight: 600;
  font-size: 18px;
  color: 000;
}
.d-h3 {
  color: 000;
  font-size: 16px;
}
.flex-start {
  display: flex;
  align-items: flex-start;
}
.flex-0 {
  width: 0;
  flex-grow: 1;
}
.flex-label {
  width: 12em;
  text-align: right;
}
.mb16 {
  margin-bottom: 16px;
}
.mb16 > div:not(:first-child) {
  margin-left: 16px;
}
.sq-b {
  border-bottom: 1px dotted rgb(217, 217, 217);
  margin-top: 16px;
}
.mt16 {
  margin-top: 16px;
}
.pb16{
    padding-bottom: 16px;
}
</style>
